import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { SessionService } from "./session.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmComponent } from "../shared/components/confirm-generic/confirm.component";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { WebSocketNotificationOrchestratorService } from "../shared/services/websocket-notification-orchestrator.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  constructor(
    private routes: Router,
    private sessionService: SessionService,
    private wsOrchestrator: WebSocketNotificationOrchestratorService,
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    const isSignedIn = await this.sessionService.isUserLoggedIn();

    if (!isSignedIn) {
      const isStoreLinkUrl = state.url.includes("store/link");
      const isStoreCallbackUrl =
        state.url.includes("store/stores") &&
        (() => {
          const queryStart = state.url.indexOf("?");
          if (queryStart === -1) return false;
          const query = new URLSearchParams(state.url.slice(queryStart + 1));
          return (
            query.has("result") ||
            query.has("id") ||
            query.has("error_code") ||
            query.has("invitations")
          );
        })();

      if (isStoreLinkUrl || isStoreCallbackUrl) {
        const message = await firstValueFrom<string>(
          this.translate.get(
            "messages.You need to sign in before linking your store. The process will automatically continue once you're signed in.",
          ),
        );
        this.dialog.open(ConfirmComponent, {
          data: {
            message: message,
            clearButtonClose: true,
          },
          disableClose: true,
        });
      }

      this.sessionService.signOutUser(state.url).then(() => {
        this.wsOrchestrator.shutdown();
      });

      return false;
    }

    return true;
  }
}
